/**
 * Determine whether the current window is on Vooxy's ROOT marketing domain
 * (vooxy.app, www.vooxy.app) versus a tenant subdomain (nilkamal.vooxy.app etc.)
 * or the preview/localhost environments.
 *
 * The marketing landing/pricing/contact pages render ONLY on the root marketing
 * host. Preview + localhost also count as "root" so we can develop the marketing
 * site without needing a real domain.
 *
 * Tenant subdomains (X.vooxy.app) skip the marketing landing entirely and go
 * straight to the login/app UX — that's what the customer sees.
 */
export default function useIsRootDomain() {
  if (typeof window === 'undefined') return true;
  const host = (window.location.hostname || '').toLowerCase();

  // Explicit marketing hosts
  if (host === 'vooxy.app' || host === 'www.vooxy.app') return true;

  // Dev / preview — allow marketing routes so we can build & test them
  if (host === 'localhost' || host === '127.0.0.1') return true;
  if (host.endsWith('.preview.emergentagent.com')) return true;
  if (host.endsWith('.emergent.host')) return true;

  // Any real subdomain of vooxy.app is a tenant → NOT root
  if (host.endsWith('.vooxy.app')) return false;

  // Unknown host — default to app behaviour (safer than showing marketing)
  return false;
}
